import { useEffect, useRef } from 'react';
import { AvailabilityListHeading } from '@shared/availability/AvailabilityListHeading';
import { VipPricingBanner } from '@shared/availability/VipPricingBanner';
import { useAvailabilityContext } from 'webReservations/context/AvailabilityContext';
import { useGuestVipTier } from 'webReservations/hooks/useGuestVipTier';
import { useFeatureFlagContext } from 'webReservations/featureFlags';
import { useTableSelectedPresentation } from '../hooks/useTableSelectedPresentation';
import { AvailabilityList } from './AvailabilityList';
import styles from './AvailabilityNavigator.scss';
import { AvailableTimesContainer } from './AvailableTimesContainer';
import { TableSelectedDetails } from './TableSelectedDetails';

export const AvailabilityNavigator = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { clearSelectedTime, selectedTime } = useAvailabilityContext();
  const { guestVipTier } = useGuestVipTier();
  const { isEnabled } = useFeatureFlagContext();
  const showTablePresentation = isEnabled('newFloorPlanTableFeatures');
  const { selectedTablePublicName } = useTableSelectedPresentation();

  const tablePublicName =
    showTablePresentation && selectedTime ? selectedTablePublicName : undefined;

  useEffect(() => {
    if (containerRef.current && selectedTime) {
      containerRef.current.scrollTop = 0;
    }
  }, [selectedTime]);

  return (
    <div className={styles.container} ref={containerRef}>
      {guestVipTier ? <VipPricingBanner variant="available" /> : null}
      {selectedTime ? (
        <>
          {tablePublicName ? (
            <p
              className={styles.tablePublicNameTop}
              data-testid="availability-selected-table-name"
            >
              {tablePublicName}
            </p>
          ) : null}
          <AvailabilityListHeading
            clearSelectedTime={clearSelectedTime}
            selectedTime={selectedTime}
          />
          {showTablePresentation ? <TableSelectedDetails /> : null}
          <AvailabilityList />
        </>
      ) : (
        <AvailableTimesContainer />
      )}
    </div>
  );
};
